module.exports = __webpack_public_path__ + "assets/img/word_course_volume3.125995ff.png";